module.exports = __webpack_public_path__ + "static/media/Commercial-Law.b0cfa242.jpg";